/**
 * Escapes 'bad' characters in string for use in RegExp()
 * @param str String to be escaped for use in RegExp
 * https://stackoverflow.com/a/6969486/1956072
 */
export function escapeRegExp(str: string) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
